
import { Component, Vue } from 'vue-property-decorator';
import { serverService } from '@/services/serverService';
import { DISCUSS_CATEGORY } from '@/services/discussService';

@Component({
    methods: {},
})
export default class ArticleTransfer extends Vue {
    mounted(): void {
        const articleId = Number(this.$route.params.articleId);
        serverService.discuss.getArticleById(articleId).then((a) => {
            const category = DISCUSS_CATEGORY.getByCode(a.subject.category);
            switch (category) {
                case DISCUSS_CATEGORY.FORUM:
                case DISCUSS_CATEGORY.NEWS:
                case DISCUSS_CATEGORY.REPORT:
                case DISCUSS_CATEGORY.CONTRIBUTE:
                case DISCUSS_CATEGORY.REVIEW:
                    this.$router.replace({
                        name: 'forum_client_post',
                        params: { category: category.code, clientCode: a.subject.key, articleId: a.id + '' },
                    });
                    break;

                case DISCUSS_CATEGORY.USER_BOARD:
                    this.$router.replace({
                        name: 'user_board_message',
                        params: { username: a.subject.key, messageID: a.id + '' },
                    });
                    break;

                case DISCUSS_CATEGORY.BLOG_BOARD:
                    this.$router.replace({
                        name: 'blog_read_message',
                        params: { id: 'b' + a.subject.key, messageID: a.id + '' },
                    });
                    break;
            }
        });
    }
}
